
import React from 'react'
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/input/containers/input.container';

export const TopicBasicInfoComponent = ({
  parentTopicsList, handleInnerFormChange, FileType, selectedTopics, Moduleslist, EntityType, Chapterslist
}: any) => {

  return (
    <>
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>

            <InputContainer
              label="Entity Type"
              labelField="Text"
              list={EntityType}
              onValueChange={(event: any) => {
                handleInnerFormChange(event.target.value, "EntityTypeName");
              }}
              optionName="Choose Entity Type"
              type="select"
              valueField="Text"
              value={selectedTopics?.EntityTypeName}
            />

            {selectedTopics?.EntityTypeName === "Module" && (
              <InputContainer
                label="Module List"
                labelField="Title"
                list={Moduleslist}
                onValueChange={(event: any) => {
                  handleInnerFormChange(event.target.value, "EntityId");
                }}
                optionName="Choose Module"
                type="select"
                valueField="ModuleId"
                value={selectedTopics?.EntityId}
              />
            )}

            {selectedTopics?.EntityTypeName === "Chapter" && (
              <InputContainer
                label="Chapters List"
                labelField="Title"
                list={Chapterslist}
                onValueChange={(event: any) => {
                  handleInnerFormChange(event.target.value, "EntityId");
                }}
                optionName="Choose Chapter"
                type="select"
                valueField="ChapterId"
                value={selectedTopics?.EntityId}
              />
            )}

            <InputContainer
              label="Title"
              labelField="Title"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Title'
                );
              }}
              type="text"
              value={selectedTopics?.Title}
            />



            <InputContainer
              label="Short Description"
              labelField="ShortDescription"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'ShortDescription'
                );
              }}
              type="text"
              value={selectedTopics?.ShortDescription}
            />

            <InputContainer
              label="Duration"
              labelField="Duration"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Duration'
                );
              }}
              type="text"
              value={selectedTopics?.Duration}
            />

            <InputContainer
              label="Resource Type"
              labelField="Text"
              list={FileType}
              onValueChange={(event: any) => {
                handleInnerFormChange(event.target.value, "ResourceType");
              }}
              optionName="Choose Resource Type"
              type="select"
              valueField="Text"
              value={selectedTopics?.ResourceType}
            />

            <InputContainer
              label="Parent Topic"
              labelField="Title"
              list={parentTopicsList}
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'ParentId'
                );
              }}
              optionName="Choose Parent Topic"
              type="select"
              valueField="Id"
              value={selectedTopics?.ParentId}
            />
            <div className='col-span-full'>
              <InputContainer
                label="Description"
                name="Description"
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event,
                    'Description'
                  )
                }}
                type="rte"
                value={selectedTopics?.Description}
              />
            </div>

          </div>
        }
        expandedPanel="BasicInfo"
        headerTitle="Basic Info"
      />
    </>

  )
}

export default TopicBasicInfoComponent;